import {
  Component,
  OnInit
} from '@angular/core';
import { BrowserModule, Title }  from '@angular/platform-browser';

@Component({

  selector: 'notfound',  // <home></home>
  providers: [  ],
  styles: [ require('./no-content.component.css') ],
  template: require('./no-content.component.html')
})
export class NoContentComponent implements OnInit {

 constructor(
    public title: Title
  ) {}

  public ngOnInit() {
        this.title.setTitle("The Tiger Club | Not Found");
  }



}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/no-content/no-content.component.ts